const maskThousand = (valueF) => {
  let value = parseFloat(valueF).toFixed(2)
  let signal = value.toString().indexOf('-')
  if (signal >= 0) {
    value = value.replace('-', '')
  }
  let num = value.split('.')
  num[0] = num[0].split(/(?=(?:...)*$)/).join('.')
  return signal >= 0 ? '-' + num.join(',') : num.join(',')
}

const maskThousandNoFixed = (valueF) => {
  let value = valueF.toString()
  let signal = value.indexOf('-')
  if (signal >= 0) {
    value = value.replace('-', '')
  }
  let num = value.split('.')
  num[0] = num[0].split(/(?=(?:...)*$)/).join('.')
  return signal >= 0 ? '-' + num.join(',') : num.join(',')
}

export {
  maskThousand,
  maskThousandNoFixed
}



// WEBPACK FOOTER //
// ./client/utils/numberMasker.js